export default function GallerySection(){
  const imgs = [
    '/assets/images/moving4.jpg',
    '/assets/images/moving5.jpg',
    '/assets/images/moving6.jpg',
  ];
  return (
    <section style={{ padding:'20px 0' }}>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(3, 1fr)', gap:8 }}>
        {imgs.map((src) => (
          <img key={src} src={process.env.PUBLIC_URL + src} alt="Moving work" style={{ width:'100%', height:160, objectFit:'cover', borderRadius:8 }} />
        ))}
      </div>
      <style>{`@media (max-width: 768px){
        section > div { grid-template-columns: 1fr 1fr; }
      }
      @media (max-width: 480px){
        section > div { grid-template-columns: 1fr; }
      }`}</style>
    </section>
  );
}
